export const setCookie = (document: Document, name: string, value: string, maxAge: number) => {
    document.cookie = `${name}=${value};max-age=${maxAge}`;
};

export const getCookie = (document: Document, name: string) => {
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((cookie) => cookie.includes(name));
    return cookie?.split('=')[1];
};
